export {default} from "./sidebar-search-filters-redux";
export const path = "/car-search-filters";